import { Component, OnInit, Input, Inject } from '@angular/core';
import { FormControl, FormGroup, AbstractControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwContext, DwMetaDataFormApi, DwFormControl, DwFormControlInit, DwFormFieldConfig,
         DwLookupInfo, DwMetaDataServiceToken, DwMetaDataService, DwQueryParam } from '@devwareapps/devware-cap';
import { debounceTime } from 'rxjs/operators';

@DwComponent({
  key: 'wachter-radio-button-list',
  name: 'Radio Button List',
  componentType: DwComponentType.formControl,
  isGlobal: true
})
@Component({
    selector: 'app-wachter-radio-button-list',
    template: `
    <div [formGroup]="formGroup" *ngIf="selected && selected.length > 0" [style]="'margin:0px;font-size:'+fontSize">
        <div dwRow>
            <div dwCol="12" *ngIf="selected && selected.length > 0 && ids && ids.length == 0">
                <b>Previous Save Results</b>
            </div>
            <div dwCol="12" *ngIf="!splitColumn">
                <div *ngFor="let item of selected; index as i;">
                    <i *ngIf="savePending(item.id)" class="fad fa-check-double" style="--fa-primary-color: #ffffff; --fa-secondary-color: #9c9c9c;"></i>
                    <i *ngIf="savedYes(item.id)" class="fad fa-check-double" style="--fa-primary-color: #008000; --fa-secondary-color: #9c9c9c;"></i>
                    <i *ngIf="savedNo(item.id)" class="fad fa-check-double" style="--fa-primary-color: #ff3232; --fa-secondary-color: #9c9c9c;"></i>
                    &nbsp;<input type="radio" *ngIf="!saveMode(item.id)" [disabled]="saveMode(item.id)" [checked]="selectedId == item.id" 
                        (change)="handleChange($event, item.id)" [id]="fieldDef?.attrName+'_'+item.id" [name]="'Active'+fieldDef?.attrName">
                    &nbsp;<label [for]="fieldDef?.attrName+'_'+item.id" [innerHtml]='item.display'></label>&nbsp;
                </div>
            </div>
        </div>
        <div dwRow *ngIf="splitColumn">
            <div dwCol="4" *ngFor="let item of selected; index as i;">
                <i *ngIf="savePending(item.id)" class="fad fa-check-double" style="--fa-primary-color: #ffffff; --fa-secondary-color: #9c9c9c;"></i>
                <i *ngIf="savedYes(item.id)" class="fad fa-check-double" style="--fa-primary-color: #008000; --fa-secondary-color: #9c9c9c;"></i>
                <i *ngIf="savedNo(item.id)" class="fad fa-check-double" style="--fa-primary-color: #ff3232; --fa-secondary-color: #9c9c9c;"></i>
                &nbsp;<input type="radio" *ngIf="!saveMode(item.id)" [disabled]="saveMode(item.id)" [checked]="selectedId == item.id" 
                      (change)="handleChange($event, item.id)" [id]="fieldDef?.attrName+'_'+item.id" [name]="'Active'+fieldDef?.attrName">
                &nbsp;<label [for]="fieldDef?.attrName+'_'+item.id" [innerHtml]='item.display'></label>&nbsp;
            </div>
            <div dwCol="4"></div><div dwCol="4"></div>
        </div>
    </div>  `,
})

export class WachterRadioButtonListComponent extends FormControl implements DwFormControl, DwFormControlInit {
    lookupItems: DwLookupInfo[] = [];
    fieldDef: DwFormFieldConfig;
    formGroup: FormGroup;
    @Input() context : DwContext;

    ids: number[] = [];
    selected: any[] = [];
    priorSelected: any[] = [];
    key: string = 'RadioList_';
    dataKey: string = '';
    defaultObj : any = null;
    splitColumn: boolean = false;
    fontSize: string = '1rem';

    emptyResults = { empty : null };
    saveResults: { [k: string]: RadioInputSaveResult; } = this.emptyResults;
    ok(id: string, t? : boolean): boolean { return this.saveResults[id] != undefined && this.saveResults[id].ok == t; };
    saveInProgress: boolean = false;

    saveMode(id: string): boolean { return this.saveResults[id] != undefined && !this.savedNo(id); };
    savePending(id: string): boolean { return this.ok(id, null); };
    savedYes(id: string): boolean { return this.ok(id, true); };
    savedNo(id: string): boolean { return this.ok(id, false); };
    get saveCompleted() : boolean { 
        const succeeded = this.savedData.find(s => this.savedYes(s.id));
        const failed = this.savedData.find(s => this.savedNo(s.id));
        /* IF at least 1 succeeded and NONE failed, this indicates that a saved completed 
         * Any with Ok == null are simply old data for ids needed UNLESS a successful save occurred */
        return succeeded != undefined && failed == undefined;
     }
     get workInProgress() : any[] { 
        return this.savedData.filter(d => this.saveResults[d.id] == undefined);
     }

    selectedId : number = 0;
    idList: any = null;
    savedData: {[k: string]: any } [] = [];

    constructor(@Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService){ super(); }

    ngOnInit() { }

    restoreData(){
        this.selectedId = null;

        var obj: {[k: string]: any} = {};
        obj[this.fieldDef.attrName] = this.idList;
        this.formGroup.patchValue(obj);

        this.savedData.forEach(d => {
            d[this.fieldDef.attrName] = this.idList;
        });
    }
    selectFirstFailure(){
        this.restoreData();
        const firstFailure = this.savedData.find(d => this.savedNo(d.id));
        if (firstFailure && firstFailure.id)
            this.handleChange(null, firstFailure.id);
    }
    completeSaveInProgress(){
        this.priorSelected = this.selected;
        this.saveInProgress = false;
    }
    reset(full: boolean = false){
        this.lookupItems = [];
        this.selectedId = 0;
        this.ids = [];
        if (full)
        {
            this.savedData = this.workInProgress;
            this.saveResults = this.emptyResults;
            this.selected = [];
        }
    }
    previous(id: number) : any {
        const previous = this.savedData.find(s => s.id == id);
        return previous || this.defaultObj;
    }
    isResetting: () => boolean
    setDisplay: (formData: any, display: string) => string;
    assignLookup(lookUpId: number | string, queryParams?: DwQueryParam[]){
        if (this.lookupItems.length == 0)
        {
            this.priorSelected = [];
            this.selected = [];
            this.dwMetaDataService
                .getLookup(lookUpId, queryParams)
                .subscribe(items => 
                { 
                    this.lookupItems = items;
                    this.defaultObj = this.formGroup.value;
                });
        }
    }

    handleChange(event, selected) {
        if (selected == 0)
            return;
     
        const current: any = this.formGroup.value;
        const clone = { ...current, id: this.selectedId };
        
        /* If currently selected value, save existing values */
        if (this.selectedId && this.selectedId > 0)
        {
            const existing = this.savedData.findIndex(s => s.id == this.selectedId);
            if (existing > -1) 
                this.savedData.splice(existing, 1);
            this.savedData.push.apply(this.savedData, [clone]);
        }

        if (selected == this.selectedId) 
            return;

        /* Updating to previous values */
        const previous = this.previous(selected);
        if (previous){
            previous[this.fieldDef.attrName] = current[this.fieldDef.attrName];
            this.formGroup.patchValue(previous);
        }
        this.selectedId = selected;
    }

    initControl(): void {
        this.dataKey = this.fieldDef?.attrName;
        this.key = `RadioList_${this.dataKey}`;
        this.formGroup.addControl(this.key, this)

        this.formGroup.valueChanges.pipe(debounceTime(200))
            .subscribe(value => {
                if (this.saveInProgress)
                    return;

                /* Track changes to the total list of values for restoration purposes post-save failure */
                this.idList = this.formGroup.get(this.fieldDef.attrName)?.value;

                /* This is in case the order of valueChange subscribers invokes this instance prior to others */
                if (this.isResetting)
                {
                    if (this.isResetting()){
                        this.reset();
                        return;
                    }
                    else
                        this.handleChange(null, this.selectedId);
                }

                const data = this.DataSource;
                const ids = data?.value?.toString() ?? '';
                const vals = ids.length == 0 ? [] : data?.value?.toString().split(",").map(Number) || []; 

                const newId = vals.find(id => this.ids.indexOf(id) == -1);
                this.ids = vals;
                const hasSelections = vals && vals.length > 0;

                if (hasSelections == false && this.priorSelected && this.priorSelected.length > 0)
                    this.selected = this.priorSelected;
                else
                    this.selected = [];

                if (newId)
                    this.handleChange(null, newId);

                if (hasSelections)
                {
                    this.priorSelected = [];
                    this.selected
                        .push.apply(this.selected, this.ids
                        .map(item => 
                        {
                            const data = this.previous(item);
                            const lookupDisplay = this.lookupItems.find(l => l.Id == item.toString())?.Display;
                            const display = this.setDisplay ? this.setDisplay(data, lookupDisplay) : lookupDisplay;
                            return ({ id: item, display: display});
                        }));
                }
            });
    }

    get PendingUpdates(): {[k: string]: RadioInputSaveResult } {
        const results: { [k: string]: RadioInputSaveResult; } = {};
        const skips: { [k: string]: RadioInputSaveResult; } = {};
        const isRetry: boolean = false;
        this.selected.forEach(item => 
            {
                const data = this.previous(item.id);
                const result = { ...item, ok: null, data: data };
                /* Exclude already saved results */
                const priorSave = this.saveResults[result.id];
                if (priorSave == undefined || priorSave.ok != true)
                    results[item.id.toString()] = result;
                else
                    skips[item.id.toString()] = priorSave;
            });
        
        this.saveResults = results;
        if (Object.keys(skips).length > 0)
            this.saveResults = { ...this.saveResults, ...skips };
        return results;
    }

    get DataSource(): AbstractControl { return this.formGroup.get(this.dataKey); }
    get RadioList(): WachterRadioButtonListComponent { return this.formGroup.get(this.key) as WachterRadioButtonListComponent; }
}

export interface RadioInputSaveResult {
    id: number; ok?: boolean; data?: any;
}
